import { Component, HostBinding, Input, OnChanges } from '@angular/core';
import { IssueStatusChip, IssueWorkflowIssue, issueStageChip } from '../../../helpers/issue-workflow';

/**
 * The status pill of an issue row / card while the issue is at a
 * contractor-workflow stage (sent_to_contractor, responded): the
 * one status the row shows for it. Renders nothing — and takes no space —
 * for an open or closed issue, where the row keeps the plain open / closed
 * pill it always had. Only a project with the workflow switched on ever gives
 * an issue a stage status, so the project itself is not consulted.
 */
@Component({
  selector: 'app-issue-stage-chip',
  templateUrl: './issue-stage-chip.component.html',
  styleUrls: ['./issue-stage-chip.component.scss'],
  standalone: false,
})
export class IssueStageChipComponent implements OnChanges {
  @Input() issue: IssueWorkflowIssue | null = null;
  /** Sized like the status pills of the issue cards (24px) rather than the detail chip. */
  @Input() compact = false;

  chip: IssueStatusChip | null = null;

  // An empty host would still be a flex item in the rows it sits in.
  @HostBinding('style.display') get display(): string | null {
    return this.chip ? null : 'none';
  }

  ngOnChanges(): void {
    this.chip = issueStageChip(this.issue);
  }
}
